/**
 * Invalidate ActionRegistry / executeData cache entries by action id.
 *
 * Cache keys are built via `buildCacheKey(actionId, params)` → `ACTION_ID` or
 * `ACTION_ID::param=value`. Invalidating the prefix drops every variant and
 * notifies `globalCache.subscribe` listeners (form-engine fetchers, etc.).
 *
 * @example
 * // After UPDATE_PARTICIPANT succeeds:
 * invalidateActionCache(['FETCH_PARTICIPANT']);
 */

import { globalCache } from './CacheManager';

/**
 * Clear cached results for the given action IDs (ActionRegistry data actions).
 * Mounted fetchers subscribed via `globalCache.subscribe(actionId, …)` will be notified.
 */
export function invalidateActionCache(actionIds: string[]): void {
  const ids = actionIds.map((id) => id?.trim()).filter(Boolean);
  for (const actionId of ids) {
    globalCache.invalidateByPrefix(actionId);
  }
}
